// import React from "react";
// import { Link } from "react-router-dom";

// const HowItWorks = () => {
//   return (
//     <div className="container my-5 py-4" style={{ maxWidth: "100%" }}>
//       {/* Header Section */}
//       <div className="text-center mb-5">
//         <h3 
//           className="display-6 text-center mb-4" 
//           style={{ color: "#000" }}
//         >
//           How does Farmhouse Store work?
//         </h3>
//         <div 
//           className="mx-auto mb-3"
//           style={{
//             width: "60px",
//             height: "4px",
//             backgroundColor: "#7dbfa2",
//             borderRadius: "2px"
//           }}
//         ></div>
//         <p 
//           className="lead mx-auto" 
//           style={{ 
//             maxWidth: "600px", 
//             color: "#666",
//             fontSize: "1.1rem"
//           }}
//         >
//           Simple steps to get fresh farm produce delivered to your doorstep through our streamlined WhatsApp ordering system
//         </p>
//       </div>

//       {/* Main Content Section */}
//       <div 
//         className="row align-items-center p-4 p-md-5 rounded-4 shadow-sm"
//         style={{ 
//           backgroundColor: "white",
//           border: "2px solid #f0f0f0",
//           transition: "all 0.3s ease"
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.borderColor = "#7dbfa2";
//           e.currentTarget.style.boxShadow = "0 15px 35px rgba(125, 191, 162, 0.15)";
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.borderColor = "#f0f0f0";
//           e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)";
//         }}
//       >
//         {/* Image section */}
//         <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
//           <div 
//             className="position-relative"
//             style={{
//               borderRadius: "20px",
//               overflow: "hidden",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
//             }}
//           >
//             <img
//               src="https://cdn.pixabay.com/photo/2020/05/21/16/27/mobile-phone-5201597_1280.jpg"
//               alt="Farmhouse delivery"
//               className="img-fluid"
//               style={{ 
//                 height: "480px", 
//                 width: "100%", 
//                 objectFit: "cover",
//                 transition: "transform 0.3s ease"
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = "scale(1.05)";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = "scale(1)";
//               }}
//             />
//             <div 
//               className="position-absolute top-0 start-0 w-100 h-100"
//               style={{
//                 background: "linear-gradient(135deg, rgba(125, 191, 162, 0.1), rgba(0,0,0,0.1))",
//                 pointerEvents: "none"
//               }}
//             ></div>
//           </div>
//         </div>

//         {/* Text list section */}
//         <div className="col-md-6">
//           <ul className="list-unstyled">
//             {[
//               {
//                 icon: "👤",
//                 text: "Click Login/Register or Sign up to create an account",
//                 highlight: false
//               },
//               {
//                 icon: "🛒",
//                 text: "Simply click on a category",
//                 highlight: false
//               },
//               {
//                 icon: "🥕",
//                 text: "Start shopping by adding products to your cart",
//                 highlight: false
//               },
//               {
//                 icon: "📱",
//                 text: "Click on 'Send Order' via WhatsApp button where you will automatically be directed to WhatsApp",
//                 highlight: true // Highlight WhatsApp related feature
//               },
//               {
//                 icon: "✅",
//                 text: "Click the 'Send' button. WA! LA! We do the rest.",
//                 highlight: false
//               },
//               {
//                 icon: "📬",
//                 text: "A confirmation will be sent to you via WhatsApp upon receiving your order",
//                 highlight: false
//               }
//             ].map((item, index) => (
//               <li 
//                 key={index}
//                 className={`mb-4 d-flex align-items-start p-3 rounded-3 ${item.highlight ? '' : ''}`}
//                 style={{
//                   backgroundColor: item.highlight ? "#7dbfa2" : "transparent",
//                   color: item.highlight ? "white" : "#333",
//                   border: item.highlight ? "none" : "2px solid transparent",
//                   transition: "all 0.3s ease",
//                   fontSize: "1.1rem",
//                   cursor: "pointer"
//                 }}
//                 onMouseEnter={(e) => {
//                   if (!item.highlight) {
//                     e.currentTarget.style.borderColor = "#7dbfa2";
//                     e.currentTarget.style.backgroundColor = "rgba(125, 191, 162, 0.05)";
//                     e.currentTarget.style.transform = "translateX(10px)";
//                   } else {
//                     e.currentTarget.style.backgroundColor = "#6ba892";
//                     e.currentTarget.style.transform = "translateX(10px) scale(1.02)";
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   if (!item.highlight) {
//                     e.currentTarget.style.borderColor = "transparent";
//                     e.currentTarget.style.backgroundColor = "transparent";
//                     e.currentTarget.style.transform = "translateX(0)";
//                   } else {
//                     e.currentTarget.style.backgroundColor = "#7dbfa2";
//                     e.currentTarget.style.transform = "translateX(0) scale(1)";
//                   }
//                 }}
//               >
//                 <span 
//                   className="me-3 d-flex align-items-center justify-content-center"
//                   style={{
//                     fontSize: "1.5rem",
//                     width: "40px",
//                     height: "40px",
//                     backgroundColor: item.highlight ? "rgba(255,255,255,0.2)" : "#7dbfa2",
//                     borderRadius: "12px",
//                     flexShrink: 0
//                   }}
//                 >
//                   {item.highlight ? "📱" : item.icon}
//                 </span>
//                 <span style={{ lineHeight: "1.6" }}>
//                   {item.text}
//                 </span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>


//     </div>
//   );
// };

// export default HowItWorks;


import React from "react";

const HowItWorks = () => {
  return (
    <div className="container my-3 py-3" style={{ maxWidth: "100%" }}>
      {/* Header Section */}
      <div className="text-center mb-4">
        <h3 
          className="h4 text-center mb-3" 
          style={{ color: "#000" }}
        >
          How does Farmhouse Store work?
        </h3>
        <div 
          className="mx-auto mb-2"
          style={{
            width: "60px",
            height: "4px",
            backgroundColor: "#7dbfa2",
            borderRadius: "2px"
          }}
        ></div>
        <p 
          className="mx-auto" 
          style={{ 
            maxWidth: "600px", 
            color: "#666",
            fontSize: "1rem"
          }}
        >
          Simple steps to get fresh farm produce delivered to your doorstep through our streamlined WhatsApp ordering system
        </p>
      </div>

      {/* Main Content Section */}
      <div 
        className="row align-items-center p-3 rounded-3 shadow-sm"
        style={{ 
          backgroundColor: "white",
          border: "2px solid #f0f0f0",
          transition: "all 0.3s ease"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = "#7dbfa2";
          e.currentTarget.style.boxShadow = "0 15px 35px rgba(125, 191, 162, 0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = "#f0f0f0";
          e.currentTarget.style.boxShadow = "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)";
        }}
      >
        {/* Image section */}
        <div className="col-md-6 mb-3 mb-md-0 d-flex justify-content-center">
          <div 
            className="position-relative"
            style={{
              borderRadius: "15px",
              overflow: "hidden",
              boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
            }}
          >
            <img
              src="https://cdn.pixabay.com/photo/2020/05/21/16/27/mobile-phone-5201597_1280.jpg"
              alt="Farmhouse delivery"
              className="img-fluid"
              style={{ 
                height: "320px", 
                width: "100%", 
                objectFit: "cover",
                transition: "transform 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            />
            <div 
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: "linear-gradient(135deg, rgba(125, 191, 162, 0.1), rgba(0,0,0,0.1))",
                pointerEvents: "none"
              }}
            ></div>
          </div>
        </div>

        {/* Text list section */}
        <div className="col-md-6">
          <ul className="list-unstyled">
            {[
              {
                text: "Click Login/Register or Sign up to create an account",
                highlight: false
              },
              {
                text: "Simply click on a category",
                highlight: false
              },
              {
                text: "Start shopping by adding products to your cart",
                highlight: false
              },
              {
                text: "Click on 'Send Order' via WhatsApp button where you will automatically be directed to WhatsApp",
                highlight: true // Highlight WhatsApp related feature
              },
              {
                text: "Click the 'Send' button. WA! LA! We do the rest.",
                highlight: false
              },
              {
                text: "A confirmation will be sent to you via WhatsApp upon receiving your order",
                highlight: false
              }
            ].map((item, index) => (
              <li 
                key={index}
                className={`mb-2 d-flex align-items-start p-2 rounded-2`}
                style={{
                  backgroundColor: item.highlight ? "#7dbfa2" : "transparent",
                  color: item.highlight ? "white" : "#333",
                  border: item.highlight ? "none" : "2px solid transparent",
                  transition: "all 0.3s ease",
                  fontSize: "0.95rem",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  if (!item.highlight) {
                    e.currentTarget.style.borderColor = "#7dbfa2";
                    e.currentTarget.style.backgroundColor = "rgba(125, 191, 162, 0.05)";
                    e.currentTarget.style.transform = "translateX(5px)";
                  } else {
                    e.currentTarget.style.backgroundColor = "#6ba892";
                    e.currentTarget.style.transform = "translateX(5px) scale(1.01)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!item.highlight) {
                    e.currentTarget.style.borderColor = "transparent";
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.transform = "translateX(0)";
                  } else {
                    e.currentTarget.style.backgroundColor = "#7dbfa2";
                    e.currentTarget.style.transform = "translateX(0) scale(1)";
                  }
                }}
              >
                <span 
                  className="me-2 d-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "1rem",
                    width: "24px",
                    height: "24px",
                    backgroundColor: item.highlight ? "rgba(255,255,255,0.2)" : "#7dbfa2",
                    borderRadius: "50%",
                    flexShrink: 0,
                    color: item.highlight ? "white" : "white",
                    fontWeight: "bold"
                  }}
                >
                  ✓
                </span>
                <span style={{ lineHeight: "1.5" }}>
                  {item.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;